<template>
  <div class="mark-overll" v-if="chartlist">
    <div
      id="marke-lgb"
      class="tire draggable"
      v-if="chartlist.length"
      style="top: 1%; left: 35%; z-index: 9999; cursor:move"
      :style="{ top: element.top + 'px', left: element.left + 'px' }"
      @mousedown="dragStart"
      @touchstart="dragStart"
    >
      <div
        class="tire-detail"
        :style="`${chartlist.length > 9 ? 'height:465px' : ''}`"
      >
        <div class="detail-head">{{ equip_data.name }}</div>
        <div
          :class="['detail-main', chartlist.length > 9 && 'scroll-hover']"
          :style="`${
            chartlist.length > 9
              ? 'height: 300px;overflow: hidden;  padding-right: 10px;'
              : ''
          }`"
        >
          <div
            v-for="(item, index) in chartlist"
            :key="index"
            class="detail-cont"
          >
            <label>{{ item.name }}:</label>
            <!-- 报警状态常量值 -->
            <div :class="checkValue(item.stat)">
              <span>{{ item.v }}</span>
              <span class="ps-1">{{ item.unit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment/moment";
// import {linesRelationChart} from "@/minix";
import { reactive, toRefs } from "vue";
export default {
  setup() {
    const state = reactive({
      dragging: false,
      element: {
        top: 0,
        left: 720,
      },
      initialPosition: {
        x: 0,
        y: 0,
      },
      initialMousePosition: {
        x: 0,
        y: 0,
      },
    });

    function dragStart(event) {
      event.preventDefault();
      state.dragging = true;
      state.initialMousePosition.x = event.clientX || event.touches[0].clientX;
      state.initialMousePosition.y = event.clientY || event.touches[0].clientY;
      state.initialPosition.x = state.element.left;
      state.initialPosition.y = state.element.top;

      document.addEventListener("mousemove", drag);
      document.addEventListener("touchmove", drag);
      document.addEventListener("mouseup", dragEnd);
      document.addEventListener("touchend", dragEnd);
    }

    function drag(event) {
      if (state.dragging) {
        const moveX = event.clientX || event.touches[0].clientX;
        const moveY = event.clientY || event.touches[0].clientY;
        if (
          state.initialPosition.x + (moveX - state.initialMousePosition.x) >
            1600 ||
          state.initialPosition.x + (moveX - state.initialMousePosition.x) <
            400 ||
          state.initialPosition.y + (moveY - state.initialMousePosition.y) >
            670 ||
          state.initialPosition.y + (moveY - state.initialMousePosition.y) < -10
        ) {
          return;
        }
        state.element.left =
          state.initialPosition.x + (moveX - state.initialMousePosition.x);
        state.element.top =
          state.initialPosition.y + (moveY - state.initialMousePosition.y);
      }
    }

    function dragEnd() {
      state.dragging = false;
      document.removeEventListener("mousemove", drag);
      document.removeEventListener("touchmove", drag);
      document.removeEventListener("mouseup", dragEnd);
      document.removeEventListener("touchend", dragEnd);
    }

    return { ...toRefs(state), dragStart, drag, dragEnd };
  },
  data() {
    return {
      isDragging: false,
      position: {
        x: 0,
        y: 0,
      },
      offset: {
        x: 0,
        y: 0,
      },
      time: null,
      num: 1,
      timer3: null,
      numList: [
        [950, 951, 950, 951, 1000, 700, 800, 698, 40, 40, 950, 951, 950, 951],
        [
          7804, 7825, 7793, 7815, 7200, 5268, 6237, 4876, 3000, 3000, 7814,
          7820, 7823, 7826,
        ],
        [40, 41, 39, 40, 45, 50, 52, 48, 40, 40, 40, 41, 39, 41],
        [331, 333, 328, 331, 338, 127, 181, 107, 74, 74, 331, 333, 328, 333],
      ],
      demoNumList: [0, 0, 0, 0],
      demoNum: 0,
    };
  },
  props: {
    //设备信息数据
    equip_data: {
      type: Object,
      default: () => {},
    },
    //推送测点数据
    chartlist: Array,
    markeData: {
      type: Object,
      default: () => {},
    },
    NuJuState: {
      type: String,
      default: "normal",
    },
  },
  methods: {
    //颜色展示是否超过阈值 HEALTH 0, WARNING 1, ERROR 2
    checkValue(value) {
      if (value == 0) {
        return "normal";
      }
      if (value == 1) {
        return "warning";
      }
      if (value == 2) {
        return "error";
      }
    },
    // checkValue(value) {
    //   if (value >= 0 && value < 2.5) {
    //     return "normal";
    //   }
    //   if (value >= 2.5 && value < 5) {
    //     return "warning";
    //   }
    //   if (value >= 5) {
    //     return "error";
    //   }
    // },
    checkNuJu(value) {
      if (value < 29.7) {
        this.$emit("update:NuJuState", "normal");
        return "normal";
      }
      if (value >= 29.7 && value < 34.5) {
        this.$emit("update:NuJuState", "warning");
        return "warning";
      }
      if (value >= 34.5) {
        this.$emit("update:NuJuState", "error");
        return "error";
      }
    },
  },
  components: {},
  watch: {},
  computed: {
    numberset() {
      return this.num || 0;
    },
    numView() {
      return this.$route.query.index || 1;
    },
  },
  mounted() {
    this.time = setInterval(() => {
      this.num++;
      if (this.num > 3) {
        this.num = 1;
      }
    }, 3000);
    let num1 = 0;
    let num2 = 0;
    let num3 = 0;
    let num4 = 0;
    this.timer3 = setInterval(() => {
      if (num1 == this.numList[0].length - 1) {
        num1 = 0;
      }
      if (num2 == this.numList[1].length - 1) {
        num2 = 0;
      }
      if (num3 == this.numList[2].length - 1) {
        num3 = 0;
      }
      if (num4 == this.numList[3].length - 1) {
        num4 = 0;
      }
      this.demoNumList = [
        this.numList[0][num1],
        this.numList[1][num2],
        this.numList[2][num3],
        this.numList[3][num4],
      ];
      num1 += 1;
      num2 += 1;
      num3 += 1;
      num4 += 1;
    }, 1000);
  },
  unmounted() {
    clearInterval(this.time);
    clearInterval(this.timer3);
  },
};
</script>

<style scoped lang="scss">
.scroll-hover:hover {
  overflow: auto !important;
}
.scroll-hover:hover::-webkit-scrollbar {
  height: 5px;
}
.tire {
  position: absolute;
  width: 300px;
  padding: 10px;
  border-radius: 10px;
  z-index: 2;
}
.tire-detail {
  position: absolute;
  min-width: 300px;
  background: url("../../../assets/工单框.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;

  .detail-head {
    padding: 5px 0 5px 10px;
    margin: 1.5px 1.5px 0;
    background: linear-gradient(90deg, #00618b 0%, #00aeb8 100%);
    border-top-left-radius: 15px;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 600;
  }
  .detail-main {
    flex: 1;
    background: rgba(0, 174, 184, 0.2);
    border-bottom-right-radius: 51px;
    box-sizing: border-box;
    font-size: 16px;
    .detail-cont {
      display: flex;
      padding: 5px 0 5px 10px;
      label {
        flex: 1.5;
        margin-right: 0px;
      }
      div {
        flex: 1;
        font-weight: bold;
      }
    }
  }
}
.tire-line-dot-detail {
  width: 135px;
  height: 2px;
  background: linear-gradient(90deg, #01e7ff 0%, #0165a6 100%);
  transform: matrix(-1, 0, 0, 1, 0, 0);
  opacity: 0.8;
  transform: rotate(-45deg);
  position: absolute;
  top: -35px;
  left: -2px;
  z-index: -1;
}

.normal {
  color: #fff;
}
.warning {
  color: #ffd643;
}
.error {
  color: #ff706f;
}
@keyframes scale {
  0% {
    transform: scale(1);
  }

  50%,
  75% {
    transform: scale(3);
  }

  78%,
  100% {
    opacity: 0;
  }
}

@keyframes scales {
  0% {
    transform: scale(1);
  }

  50%,
  75% {
    transform: scale(2);
  }

  78%,
  100% {
    opacity: 0;
  }
}

.smallcircle2 {
  width: 12px;
  height: 12px;
  background-color: #00d6f1;
  border-radius: 50%;
}

.smallcircle2:before {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0.4;
  background-color: #28e6ff;
  animation: scale 1s infinite cubic-bezier(0, 0, 0.49, 1.02);
}
</style>
